import { useStoreActions } from 'easy-peasy';

function useSnackBar() {
  return useStoreActions((actions) => actions.snackBar.setMessage);
}

export { useSnackBar };
